import { Field } from 'module/api/field/types';
import { SourceType } from 'module/api/filter/types';
import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { unreachable } from '../unreachable';

const calculatedFieldTypeMap = {
  currentPhases: FieldType.Text,
  actualStartDate: FieldType.Date,
  actualCompletedDate: FieldType.Date,
  customerCompanyName: FieldType.Text,
  completionPercentage: FieldType.Number,
  projectTrackedHours: FieldType.Number,
  totalBillableHours: FieldType.Number,
  overallRating: FieldType.Number,
  lastMilestoneRating: FieldType.Number,
  projectAge: FieldType.Number,
  plannedDuration: FieldType.Number,
  completedTasks: FieldType.Number,
  overdueTasks: FieldType.Number,
  blockedTasks: FieldType.Number,
  atRiskTasks: FieldType.Number,
  approvalPending: FieldType.Number,
};

export const filterableFieldType = (field: Field): FieldType => {
  if (field.fieldName === 'assignee') {
    return FieldType.Assignee;
  }

  if (field.fieldName === 'estimatedDueDate') {
    return FieldType.Estimate;
  }

  if (calculatedFieldTypeMap[field.fieldName]) {
    return calculatedFieldTypeMap[field.fieldName];
  }

  const type = field.optionsAvailable ? field.fieldType : field.fieldDataType;

  switch (type) {
    case 'BOOLEAN':
      return FieldType.Boolean;
    case 'NUMBER':
      return FieldType.Number;
    case 'TEXT':
      return FieldType.Text;
    case 'MULTI_LINE_TEXT':
      return FieldType.MultiLineText;
    case 'DATE':
      return FieldType.Date;
    case 'USER':
      return field.fieldType === 'SINGLE_SELECT'
        ? FieldType.SingleUser
        : FieldType.MultiUser;
    case 'SINGLE_SELECT':
      return FieldType.SingleSelect;
    case 'MULTI_SELECT':
      return field.fieldDataType === 'NOTE'
        ? FieldType.Note
        : FieldType.MultiSelect;
    case 'NOTE':
      return FieldType.Note;
    default:
      return unreachable(type as never);
  }
};
export const fieldToFilterableField = (
  field: Field,
  sourceType: SourceType,
): FilterableField => {
  return {
    ...field,
    type: filterableFieldType(field),
    sourceType,
  } as FilterableField;
};
